import Model, { attr } from '@ember-data/model';
import { type IntervalDate } from 'donor-elf-web/lib/journal-utils';

export default class JournalDashboardModel extends Model {
  @attr('string') declare journalId: string;
  @attr('string') declare intervalTimespan: string;
  @attr('string') declare firstDayOfWeek: string;
  @attr() declare intervalDates: IntervalDate[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'journal-dashboard': JournalDashboardModel;
  }
}
